import { render, staticRenderFns } from "./ChatContainer.vue?vue&type=template&id=1481448a&scoped=true&"
import script from "./ChatContainer.vue?vue&type=script&lang=js&"
export * from "./ChatContainer.vue?vue&type=script&lang=js&"
import style0 from "./ChatContainer.vue?vue&type=style&index=0&id=1481448a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1481448a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1481448a')) {
      api.createRecord('1481448a', component.options)
    } else {
      api.reload('1481448a', component.options)
    }
    module.hot.accept("./ChatContainer.vue?vue&type=template&id=1481448a&scoped=true&", function () {
      api.rerender('1481448a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/components/chat/ChatContainer.vue"
export default component.exports